module.exports = __webpack_public_path__ + "h5/img/dfk001.d081e342.gif";